import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from "rxjs";
import { I18nService } from "../../../shared/services/i18n.service";
import { OnboardingDocument } from "../../../profile/models/onboarding.model";
import { FileUploadService } from "../../services/fileUpload.service";
import { SupplierDocumentService } from '../../../profile/services/supplier-document.service';
import { DocumentType } from '../../../profile/models/supplier.model';

@Component({
    selector: 'documents-dialog',
    templateUrl: './documents-dialog.component.html'
})
export class DocumentsDialogComponent implements OnDestroy, OnInit {

    errorMessage: string = '';
    fileUploadSub: Subscription;
    invalidDoc: boolean = false;
    types: DocumentType[] = [];
    categories: string[] = [];
    constructor(
        @Inject(MAT_DIALOG_DATA) private params: { documentData: OnboardingDocument, supplierCode: string },    //  Get parameters from parent component
        private fileUploadService: FileUploadService,
        public dialogRef: MatDialogRef<DocumentsDialogComponent>,
        private translate: I18nService,
        private documentService: SupplierDocumentService
    ) { }

    ngOnInit() {
        this.documentService.getDocumentType().subscribe(res => {
            this.types = res;
        });
    }

    ngOnDestroy(): void {
        if (this.fileUploadSub) {
            this.fileUploadSub.unsubscribe();
        }
    }

    closeDialog() {
        this.dialogRef.close();
    }

    onFileAdd(files: FileList) {

        if (files.length == 1) {
            this.errorMessage = '';

            //  Select only the first file
            let file = files[0];
            this.validateFile(file);

            if(!this.invalidDoc){
                this.fileUploadSub = this.fileUploadService.uploadFileToServer([file], this.params.supplierCode, { 'DocumentType': this.params.documentData.DocumentType }).subscribe(resp => {
                    //  Map response data to document data
                    this.params.documentData.DocumentID = resp['documentID'] || resp.DocumentID;
                    this.params.documentData.DocumentVersion = resp['documentVersion'] || resp.DocumentVersion;
                    this.params.documentData.FileName = resp['fileName'] || resp.FileName;
                    this.params.documentData.FileNameGuid = resp['fileNameGuid'] || resp.FileNameGuid;
                    this.params.documentData.UploadedDate = new Date();
                    this.params.documentData.File = file;
                    //  Self close the dialog after submitting
                    if (!this.invalidDoc) {
                        this.dialogRef.close();
                    }
                }, err => this.errorMessage = this.translate.get(err));
            }
        } else if (files.length >= 1) {
            this.errorMessage = this.translate.get('Please only select one file.');
        } else {
            this.errorMessage = this.translate.get('File is required.');
        }
    }

    validateFile(file: File) {
        if (file) {
            var ext = file.name.substring(file.name.lastIndexOf('.') + 1);
            var supplierDoc = this.types.find(x => x.name == this.params.documentData.DocumentType);
            if (supplierDoc && supplierDoc.allowedExtensions) {
                if (!supplierDoc.allowedExtensions.toLowerCase().split(',').includes(ext.toLowerCase())) {
                    this.invalidDoc = true;
                    this.errorMessage = 'Document selected is not in valid format, only ' + supplierDoc.allowedExtensions + ' files are allowed!';
                }
                else {
                    this.invalidDoc = false;
                }
            }
        }
    }
}
